<p>data-generic works!</p>
